import '/node_modules/react-grid-layout/css/styles.css';
import '/node_modules/react-resizable/css/styles.css';

import i18n from 'i18next';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {initReactI18next} from 'react-i18next';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import {App} from './App';
import en from './i18n/en';
import {store} from './redux/store';
import reportWebVitals from './reportWebVitals';

i18n.use(initReactI18next).init({
  resources: {en},
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

const element = document.getElementById('root');
const root = ReactDOM.createRoot(element!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
